import { useMemo } from 'react';
import { DatePickerField } from './DatePickerField';
import { todayISO, addDaysISO } from '@/lib/format';
import { useBlockedDates, useBookingWindow } from '@/hooks/queries';
import { DEFAULT_PRESALE_WINDOW_DAYS } from '@/api/bookingWindow.api';

interface VisitDatePickerProps {
  value: string;
  onChange: (dateISO: string) => void;
  /**
   * Fallback window length in days (today..+maxDays), used only until the
   * park-wide booking window loads or when it cannot be fetched.
   */
  maxDays?: number;
}

/**
 * Visit-date chooser bounded by the park-wide booking window (Asia/Jakarta),
 * shown as dd-mm-yyyy — the same range the sale endpoint enforces (#1488).
 * Operator-blocked dates (public blocked-dates feed) cannot be picked.
 */
export function VisitDatePicker({ value, onChange, maxDays = DEFAULT_PRESALE_WINDOW_DAYS }: VisitDatePickerProps) {
  const { data: blocks } = useBlockedDates();
  const { data: window } = useBookingWindow();
  const disabledRanges = useMemo(
    () => (blocks ?? []).map((b) => ({ from: b.dateFrom, to: b.dateTo })),
    [blocks],
  );

  return (
    <DatePickerField
      value={value}
      onChange={onChange}
      min={todayISO()}
      max={window?.maxDate ?? addDaysISO(maxDays)}
      disabledRanges={disabledRanges}
      prefix="Kunjungan:"
      placeholder="Pilih tanggal"
    />
  );
}
